import { toastError, toastSuccess } from '@components/Toast/Toast';
import { useBankProfile } from '@contexts/BankProfileContext';
import { useAuth } from '@hooks/useAuth';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import type { CreatePaymentTemplate } from 'types/templates';

interface CreateTemplateParams {
	successKey?: string;
	errorKey?: string;
}

export const useCreateTemplate = (
	{ successKey = 'success', errorKey = 'failed' }: CreateTemplateParams = {
		successKey: 'success',
		errorKey: 'failed',
	},
) => {
	const { session } = useAuth();
	const { selectedProfile } = useBankProfile();
	const { t } = useTranslation('', { keyPrefix: 'payments.templates' });

	const handleCreateTemplate = async (payload: CreatePaymentTemplate) => {
		const { data } = await axios.post(
			`${import.meta.env.VITE_API_HOST}/api/v1/profiles/${selectedProfile.id}/payment-templates`,
			payload,
			{
				headers: {
					Authorization: session?.tokenized,
				},
			},
		);

		return data;
	};

	return useMutation({
		mutationFn: handleCreateTemplate,
		onSuccess: () => {
			toastSuccess(t(successKey));
		},
		onError: (err) => {
			toastError(t(errorKey));

			throw err;
		},
	});
};
